import ContentTypeNovelties from './ContentTypeNovelties';

export default ContentTypeNovelties;